const CAN_SEND = import.meta.env.VITE_IS_DEBUG === 'false';

// GTMのイベントパラメータの型定義
interface GTagEventParams {
  page_path?: string;
  page_location?: string;
  page_title?: string;
  [key: string]: unknown; // カスタムパラメータ用
}

// DataLayerの型定義
type DataLayerArray = Array<{
  event?: string;
  [key: string]: unknown;
}>;

// Gtagの型定義
type GTagFunction = (command: 'event' | 'config' | 'js', action: string | Date, params?: GTagEventParams) => void;

// グローバルオブジェクトの拡張
declare global {
  interface Window {
    dataLayer: DataLayerArray;
    gtag: GTagFunction;
  }
}

// GAイベント送信用の関数
export const sendGAEvent = (eventName: string, eventParams?: GTagEventParams) => {
  if (!CAN_SEND) {
    // console.log('GA Event (dev):', eventName, eventParams);
    return;
  }

  if (CAN_SEND && typeof window.gtag === 'function') {
    window.gtag('event', eventName, eventParams);
  }
};

// GTMイベント送信用の関数
export const sendGTMEvent = (eventName: string, eventParams?: Record<string, unknown>) => {
  if (!CAN_SEND) {
    // console.log('GTM Event (dev):', eventName, eventParams);
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...eventParams
  });
};

// 特定のイベント名に対する型付けされたイベントパラメータの例
export interface PageViewEventParams extends GTagEventParams {
  page_path: string;
  page_location: string;
  page_title: string;
}

export interface ButtonClickEventParams extends GTagEventParams {
  button_label: string;
  page_location: string;
}

// 型付けされたイベント送信関数の例
export const sendPageViewEvent = (params: PageViewEventParams) => {
  sendGAEvent('page_view', params);
};

export const sendButtonClickEvent = (params: ButtonClickEventParams) => {
  sendGAEvent('button_click', params);
};
